import React,{useState} from 'react'
import { useAppData } from '../../../../context/AppDataContext';
import { Edit, Save } from '@mui/icons-material';
import associateProfileServices from '../associateProfileServices';

const ProfileEditor = ({label, fieldType, fieldName, value}) =>{

    const {getAssociateProfile} = useAppData();

    const [inputValue,setInputValue] = useState(value?value:"");
    const [editStatus,setEditStatus] = useState(false)
    const save = ()=>{
        const payload = {
            [fieldName]: inputValue
        }
        associateProfileServices.save(payload).then(res=>{
            console.log(res.data);
            setEditStatus(false);
            getAssociateProfile();
        }).catch(error=>{
            console.log(error);
        })
    } 

    return (
        <div className='row mb-3'>
            <div className='col-md-6'><span className='fw-bold'>{label}</span></div>
            <div className='col-md-6'>
                {editStatus ?
                    <div className="input-group input-group-sm">
                        <input  className="form-control" type={fieldType}
                            value={inputValue} onChange={(e)=>setInputValue(e.target.value)}
                        />
                        <button className="btn btn-outline-secondary" type='button' onClick={()=>save()}><Save/> </button>
                    </div>
                :
                    <div className="input-group input-group-sm">
                        <input type="text" className="form-control" disabled={true} value={inputValue} />
                        <button className="btn btn-outline-secondary" type='button' onClick={()=>setEditStatus(true)} ><Edit/></button>
                    </div>
                }
            </div>
        </div>
    )
}

export default ProfileEditor